"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.securityUtil = void 0;
var _request = require("./request");
var _cacheUtil = require("./cacheUtil");
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class securityUtil {
  static isLoggedIn() {
    const token = _cacheUtil.cacheUtil.getItem("token");
    const tenantid = _cacheUtil.cacheUtil.getItem("tenantid");
    return token && tenantid;
  }
  static forgotPassword(values, callback) {
    let req = new _request.request(securityUtil.endpoints.forgotpassword);
    req.post(values, response => {
      if (response.isError) {
        //Fail
        callback(response);
      } else {
        //Error
        callback(response);
      }
    });
  }
  static changePassword(values, callback) {
    let req = new _request.request(securityUtil.endpoints.changepassword);
    req.post(values, response => {
      if (response.isError) {
        //Fail
        callback(response);
      } else {
        //Error
        callback(response);
      }
    });
  }
  static register(values, callback) {
    let req = new _request.request(securityUtil.endpoints.register);
    req.post(values, response => {
      if (response.isError) {
        //Fail
        callback(response);
      } else {
        //Error
        callback(response);
      }
    });
  }
  static logout(returnURL) {
    let req = new _request.request(securityUtil.endpoints.logout);
    req.post().then(response => {
      _cacheUtil.cacheUtil.removeItem("token");
      _cacheUtil.cacheUtil.removeItem("tenantid");

      /* Return back to returnURL */
      window.location.href = returnURL;
      return response;
    });
  }
  static async login(values, rerouteURL, errorCallback) {
    let req = new _request.request(securityUtil.endpoints.login);
    return req.post(values).then(response => {
      if (response === undefined || response.error) {
        errorCallback(response);
        return response;
      }

      //Success
      const data = response.content;
      if (data === undefined) {
        errorCallback("data not found.");
        return response;
      }
      if (data.token) {
        _cacheUtil.cacheUtil.setItem("token", data.token, false);
      }
      if (data.tenantId) {
        _cacheUtil.cacheUtil.setItem("tenantid", data.tenantId, false);
      }
      window.location.assign(rerouteURL ? rerouteURL : "/");
      return data;
    });
  }
}
exports.securityUtil = securityUtil;
_defineProperty(securityUtil, "endpoints", {
  register: "/register",
  login: "/authenticate",
  forgotpassword: "/reset",
  changepassword: "/updatepassword",
  logout: "/logout",
  refreshtoken: "/refreshtoken"
});
;